import { render, staticRenderFns } from "./LayoutSetup.vue?vue&type=template&id=37f02a0a&"
import script from "./LayoutSetup.vue?vue&type=script&lang=js&"
export * from "./LayoutSetup.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSetup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports